if (!customElements.get('sky-product-description-accordion')) {
  customElements.define(
    'sky-product-description-accordion',
    class SkyProductDescriptionAccordion extends HTMLElement {
      connectedCallback() {
        this.items = Array.from(this.querySelectorAll('details'));
        this.onToggle = this.onToggle.bind(this);
        this.items.forEach((item) => item.addEventListener('toggle', this.onToggle));
      }

      disconnectedCallback() {
        this.items.forEach((item) => item.removeEventListener('toggle', this.onToggle));
      }

      onToggle(event) {
        const currentItem = event.currentTarget;

        if (!currentItem.open) return;

        this.items.forEach((item) => {
          if (item !== currentItem) {
            item.removeAttribute('open');
          }
        });
      }
    }
  );
}
